import moment from 'moment';

import searchRecommendApi from './api/searchRecommendApi';
/* ACTIONS */
export const OPENSEARCH_DAILYACTIVECOUNTRY = 'OPENSEARCH/DAILYACTIVECOUNTRY';
export const OPENSEARCH_DAILYACTIVEUSER = 'OPENSEARCH/DAILYACTIVEUSERS';
export const OPENSEARCH_DAILYNEWUSER = 'OPENSEARCH/DAILYNEWUSERS';
export const OPENSEARCH_DAILYNEWUSERBYAPPNAME = 'OPENSEARCH/DAILYNEWUSERSBYAPPNAME';
export const OPENSEARCH_FIRSTPURCHASE = 'OPENSEARCH/FIRSTPURCHASE';
export const OPENSEARCH_FIRSTPURCHASETOTAL = 'OPENSEARCH/FIRSTPURCHASETOTAL';
export const OPENSEARCH_TOPWATCHCONTENT = 'OPENSEARCH/TOPWATCHCONTENT';
export const OPENSEARCH_ACTIVEUSERTOTAL = 'OPENSEARCH/ACTIVEUSERTOTAL';
export const OPENSEARCH_NEWUSERTOTAL = 'OPENSEARCH/NEWUSERTOTAL';
export const OPENSEARCH_TOP10MOVIE = 'OPENSEARCH/TOP10MOVIE';
export const OPENSEARCH_TOP10SERIES = 'OPENSEARCH/TOP10SERIES';
export const OPENSEARCH_ACTIVEUSERPLATFORM = 'OPENSEARCH/ACTIVEUSERPLATFORM';
export const OPENSEARCH_MOVIELIST = 'OPENSEARCH/MOVIELIST';
export const OPENSEARCH_SERIESLIST = 'OPENSEARCH/SERIESLIST';
export const OPENSEARCH_PLUSPURCHASERENT = 'OPENSEARCH/PLUSPURCHASERENT';
export const OPENSEARCH_PLUSPURCHASEBUY = 'OPENSEARCH/PLUSPURCHASEBUY';
export const OPENSEARCH_BUSWITCH = 'OPENSEARCH/BUSWITCH';
export const OPENSEARCH_DEVICECOVERAGE = 'OPENSEARCH/DEVICECOVERAGE';


export const SPICONFIG_LIST = 'SPICONFIG/LIST';
export const SPICONFIG_UPDATE = 'SPICONFIG/UPDATE';

export const TRENDASSET_LIST = 'TREND/ASSET/LIST';
export const TRENDCDN_LIST = 'TREND/CDN/LIST';
export const TRENDHOSTNAME_LIST = 'TREND/HOSTNAME/LIST';
export const TRENDDEVICE_LIST = 'TREND/DEVICE/LIST';
export const TRENDACCOUNT_LIST = 'TREND/ACCOUNT/LIST';
export const TRENDAPP_LIST = 'TREND/APPTYPE/LIST';
export const TRENDVIDEOTYPE_LIST = 'TREND/VIDEOTYPE/LIST';
export const TRENDISP_LIST = 'TREND/ISP/LIST';
export const TRENDERROR_LIST = 'TREND/ERROR/LIST';


export const FILTERASSET_LIST = 'FILTER/ASSET/LIST';
export const FILTERHOSTNAME_LIST = 'FILTER/HOSTNAME/LIST';
export const FILTERCOUNTRY_LIST = 'FILTER/COUNTRY/LIST';
export const FILTERDEVICE_LIST = 'FILTER/DEVICE/LIST';
export const FILTERAPP_LIST = 'FILTER/APP/LIST';
export const FILTERVIDEOTYPE_LIST = 'FILTER/VIDEOTYPE/LIST';
export const FILTERISP_LIST = 'FILTER/ISP/LIST';
export const FILTERCONCURRENT_LIST = 'FILTER/CONCURRENT/LIST';
export const FILTERACCOUNT_LIST = 'FILTER/ACCOUNT/LIST';


export const VIEWERSESSION_SETTINGS = 'VIEWERSESSION/SETTINGS';
export const VIEWERSESSION_GETLIST = 'VIEWERSESSION/GETLIST';
export const VIEWERSESSION_GETUSERLIST = 'VIEWERSESSION/GETUSERLIST';
export const VIEWERSESSION_GETFILTERLIST = 'VIEWERSESSION/GETFILTERLIST';
export const VIEWERSESSION_GETSESSIONLIST = 'VIEWERSESSION/GETSESSIONLIST';
export const VIEWERSESSION_GETERRORLIST = 'VIEWERSESSION/GETERRORLIST';
export const INSPECTIONTIME_UPDATE = 'INSPECTIONTIME/UPDATE';
export const INDEPTHFILTER_UPDATE = 'INDEPTHFILTER/UPDATE';

/* ROUTE API */
// const SPICONFIG_LIST_ROUTE = '/broadcast';

const initialState = {
	viewersessionSettings: {userAccount: "",maxStep:0, currentStep: 0, timerange:[moment().startOf('hour').add(-1,'days').add(1,'hour').toISOString(), moment().startOf('hour').add(1,'hour').toISOString()]},
	inspectionTime: {day:7, till:moment().add(1,'hour').startOf('hour').toISOString()}
};

const getOpenSearchBuckets = (data) => {
	if(data && data.responses && data.responses[0] && data.responses[0].aggregations && data.responses[0].aggregations.results && data.responses[0].aggregations.results.buckets){
		return data.responses[0].aggregations.results.buckets;
	}else{
		return [];
	}
}
const getOpenSearchAggregations = (data) => {
	if(data && data.responses && data.responses[0] && data.responses[0].aggregations ){
		return data.responses[0].aggregations;
	}else{
		return {};
	}
}
const getOpenSearchDetailList = (data) => {
	if(data && data.responses && data.responses[0] && data.responses[0].hits && data.responses[0].hits.hits ){
		return data.responses[0].hits.hits;
	}else{
		return [];
	}
}



export default (state = initialState, action) => {
	switch (action.type) {
		case SPICONFIG_LIST:
			return {
				...state,
				spiconfigList: action.payload,
			};
		case SPICONFIG_UPDATE: // WHENEVER THAT IS UPDATED
			return {
				...state,
				spiCDNList: null
			};
		case TRENDAPP_LIST:
			return {
				...state,
				trendAppList: action.payload,
			};
		case TRENDVIDEOTYPE_LIST:
			return {
				...state,
				trendVideoTypeList: action.payload,
			};
		case TRENDISP_LIST:
			return {
				...state,
				trendIspList: action.payload,
			};
		case TRENDERROR_LIST:
			return {
				...state,
				trendErrorList: action.payload,
			};
		case TRENDASSET_LIST:
			return {
				...state,
				trendAssetList: action.payload,
			};
		case TRENDCDN_LIST:
			return {
				...state,
				trendCDNList: action.payload,
			};
		case TRENDHOSTNAME_LIST:
			return {
				...state,
				trendHostnameList: action.payload,
			};
		case OPENSEARCH_DAILYACTIVECOUNTRY:
			return {
				...state,
				opensearchDailyActiveUserCountryList: action.payload,
			};
		case TRENDDEVICE_LIST:
			return {
				...state,
				trendDeviceList: action.payload,
			};
		case TRENDACCOUNT_LIST:
			return {
				...state,
				trendAccountList: action.payload,
			};
		case FILTERACCOUNT_LIST:
			return {
				...state,
				filterAccountList: action.payload,
			};
		case FILTERASSET_LIST:
			return {
				...state,
				filterAssetList: action.payload,
			};
		case FILTERHOSTNAME_LIST:
			return {
				...state,
				filterHostnameList: action.payload,
			};
		case FILTERCOUNTRY_LIST:
			return {
				...state,
				filterCountryList: action.payload,
			};
		case FILTERDEVICE_LIST:
			return {
				...state,
				filterDeviceList: action.payload,
			};
		case FILTERAPP_LIST:
			return {
				...state,
				filterAppList: action.payload,
			};
		case FILTERVIDEOTYPE_LIST:
			return {
				...state,
				filterVideoTypeList: action.payload,
			};
		case FILTERISP_LIST:
			return {
				...state,
				filterIspList: action.payload,
			};
		case FILTERCONCURRENT_LIST:
			return {
				...state,
				filterConcurrentList: action.payload,
			};
		case OPENSEARCH_DAILYACTIVEUSER:
			return {
				...state,
				opensearchDailyActiveUserList: action.payload,
			};
		case INSPECTIONTIME_UPDATE:
			delete state.spiCDNList;
			delete state.trendCDNList;
			delete state.trendHostnameList;
			delete state.opensearchDailyActiveUserCountryList;
			delete state.trendAssetList;
			delete state.trendDeviceList;
			delete state.trendAppList;
			delete state.trendVideoTypeList;
			delete state.trendIspList;
			delete state.trendErrorList;
			delete state.opensearchDailyActiveUserList;
			delete state.indepthFilter;
			delete state.filterAssetList;
			delete state.filterCountryList;
			delete state.filterDeviceList;
			delete state.filterHostnameList;
			delete state.filterAppList;
			delete state.filterVideoTypeList;
			delete state.filterIspList;
			delete state.filterConcurrentList;
			delete state.filterAccountList;
			delete state.viewersessionFilterList;
			delete state.opensearchTopWatchContentList;
			delete state.opensearchActiveUserTotalList;
			delete state.opensearchNewUserTotalList;
			delete state.opensearchDailyNewUserList;
			delete state.opensearchDailyNewUserByAppnameList;
			delete state.opensearchFirstPurchaseList;
			delete state.opensearchFirstPurchaseTotalList;
			delete state.opensearchTop10SeriesList;
			delete state.opensearchTop10MovieList;
			delete state.opensearchActiveUserByPlatformList;
			delete state.opensearchMovieList;
			delete state.opensearchSeriesList;
			delete state.opensearchPlusPurchaseRentList;
			delete state.opensearchPlusPurchaseBuyList;
			delete state.opensearchBuSwitchList;
			delete state.opensearchDeviceCoverageList;
			return {
				...state,
				inspectionTime: action.payload,
			};
		case INDEPTHFILTER_UPDATE:
			delete state.filterAssetList;
			delete state.filterCountryList;
			delete state.filterDeviceList;
			delete state.filterHostnameList;
			delete state.filterAppList;
			delete state.filterVideoTypeList;
			delete state.filterIspList;
			delete state.filterConcurrentList;
			delete state.filterAccountList;
			delete state.viewersessionFilterList;
			return {
				...state,
				indepthFilter: action.payload,
			};
		case VIEWERSESSION_SETTINGS:
			return {
				...state,
				viewersessionSettings: action.payload
			};
		case VIEWERSESSION_GETLIST:
			return {
				...state,
				viewersessionList: action.payload
			};
		case VIEWERSESSION_GETUSERLIST:
			return {
				...state,
				viewersessionUserList: action.payload,
			};
		case VIEWERSESSION_GETFILTERLIST:
			return {
				...state,
				viewersessionFilterList: action.payload,
			};
		case VIEWERSESSION_GETSESSIONLIST:
			return {
				...state,
				viewersessionSessionList: action.payload,
			};
		case VIEWERSESSION_GETERRORLIST:
			return {
				...state,
				viewersessionErrorList: action.payload,
			};
		case OPENSEARCH_DAILYNEWUSER:
			return {
				...state,
				opensearchDailyNewUserList: action.payload,
			};
		case OPENSEARCH_DAILYNEWUSERBYAPPNAME:
			return {
				...state,
				opensearchDailyNewUserByAppnameList: action.payload,
			};
		case OPENSEARCH_FIRSTPURCHASE:
			return {
				...state,
				opensearchFirstPurchaseList: action.payload,
			};
		case OPENSEARCH_FIRSTPURCHASETOTAL:
			return {
				...state,
				opensearchFirstPurchaseTotalList: action.payload,
			};
		case OPENSEARCH_TOPWATCHCONTENT:
			return {
				...state,
				opensearchTopWatchContentList: action.payload,
			};
		case OPENSEARCH_ACTIVEUSERTOTAL:
			return {
				...state,
				opensearchActiveUserTotalList: action.payload,
			};
		case OPENSEARCH_NEWUSERTOTAL:
			return {
				...state,
				opensearchNewUserTotalList: action.payload,
			};
		case OPENSEARCH_TOP10MOVIE:
			return {
				...state,
				opensearchTop10MovieList: action.payload,
			};
		case OPENSEARCH_TOP10SERIES:
			return {
				...state,
				opensearchTop10SeriesList: action.payload,
			};
		case OPENSEARCH_ACTIVEUSERPLATFORM:
			return {
				...state,
				opensearchActiveUserByPlatformList: action.payload,
			};
		case OPENSEARCH_MOVIELIST:
			return {
				...state,
				opensearchMovieList: action.payload,
			};
		case OPENSEARCH_SERIESLIST:
			return {
				...state,
				opensearchSeriesList: action.payload,
			};
		case OPENSEARCH_PLUSPURCHASERENT:
			return {
				...state,
				opensearchPlusPurchaseRentList: action.payload,
			};
		case OPENSEARCH_PLUSPURCHASEBUY:
			return {
				...state,
				opensearchPlusPurchaseBuyList: action.payload,
			};
		case OPENSEARCH_BUSWITCH:
			return {
				...state,
				opensearchBuSwitchList: action.payload,
			};
		case OPENSEARCH_DEVICECOVERAGE:
			return {
				...state,
				opensearchDeviceCoverageList: action.payload,
			};
		default:
			return state;
	}
};

export const spiconfigGetList = (organization) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/performanceConfig?account=${organization}`).then(data => {
			dispatch({
				type: SPICONFIG_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const spiconfigUpdate = (payload, paramStr) => {
	return dispatch => {
		return searchRecommendApi.patch(`/statistic/performanceConfig?${paramStr}`, payload).then(data => {
			dispatch({
				type: SPICONFIG_UPDATE
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const trendAssetGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=assetName`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: TRENDASSET_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const trendCDNGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=cdn`).then(data => {
			dispatch({
				type: TRENDCDN_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchDailyActiveUserCountry = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getDailyActiveUserCountry`).then(data => {
			dispatch({
				type: OPENSEARCH_DAILYACTIVECOUNTRY,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const opensearchDailyActiveUser = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getDailyActiveUserNew`).then(data => {
			dispatch({
				type: OPENSEARCH_DAILYACTIVEUSER,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchDailyNewUser = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getDailyNewUser`).then(data => {
			dispatch({
				type: OPENSEARCH_DAILYNEWUSER,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const trendAppGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=appType`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: TRENDAPP_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const trendVideoTypeGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=videoType`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: TRENDVIDEOTYPE_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const trendIspGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=isp`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: TRENDISP_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const trendDeviceGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=deviceType`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: TRENDDEVICE_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const trendAccountGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=useraccount`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: TRENDACCOUNT_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const trendHostnameGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=hostname`).then(data => {
			dispatch({
				type: TRENDHOSTNAME_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const trendErrorGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=error`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: TRENDERROR_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const filterAssetGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=assetName`).then(data => {
			dispatch({
				type: FILTERASSET_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const filterAccountGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=useraccount`).then(data => {
		// return api.spiconfigList(organization).then(data => {
			dispatch({
				type: FILTERACCOUNT_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const filterHostnameGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=hostname`).then(data => {
			dispatch({
				type: FILTERHOSTNAME_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const filterCountryGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=country`).then(data => {
			dispatch({
				type: FILTERCOUNTRY_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const filterAppGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=appType`).then(data => {
			dispatch({
				type: FILTERAPP_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const filterVideoTypeGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=videoType`).then(data => {
			dispatch({
				type: FILTERVIDEOTYPE_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const filterIspGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=isp`).then(data => {
			dispatch({
				type: FILTERISP_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const filterDeviceGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getTopTrendsMetrics?${paramStr}&dimension=deviceType`).then(data => {
			dispatch({
				type: FILTERDEVICE_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const filterConcurrentGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/getConcurrent?${paramStr}&dimension=timestamp`).then(data => {
			dispatch({
				type: FILTERCONCURRENT_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const indepthFilterUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INDEPTHFILTER_UPDATE,
			payload: data
		});
	};
};

export const inspectionTimeUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INSPECTIONTIME_UPDATE,
			payload: data
		});
	};
};

export const viewersessionUpdateSettings = (data) => {
	return dispatch => {
		dispatch({
			type: VIEWERSESSION_SETTINGS,
			payload: data
		});
	};
};

export const viewersessionGetList = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/statistic/listAccountName?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetUserList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETUSERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetFilterList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETFILTERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetSessionList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETSESSIONLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetErrorList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return searchRecommendApi.get(`/statistic/listErrorSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETERRORLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const opensearchDailyNewUserByAppname = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getDailyNewUserByAppname`).then(data => {
			dispatch({
				type: OPENSEARCH_DAILYNEWUSERBYAPPNAME,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchFirstPurchase = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getFirstPurchaseUser`).then(data => {
			dispatch({
				type: OPENSEARCH_FIRSTPURCHASE,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchFirstPurchaseTotal = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getFirstPurchaseUserTotal`).then(data => {
			dispatch({
				type: OPENSEARCH_FIRSTPURCHASETOTAL,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchTopWatchContent = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getTopWatchContent`).then(data => {
			dispatch({
				type: OPENSEARCH_TOPWATCHCONTENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchActiveUserTotal = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getActiveUserTotal`).then(data => {
			dispatch({
				type: OPENSEARCH_ACTIVEUSERTOTAL,
				payload: getOpenSearchAggregations(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchNewUserTotal = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getNewUserTotal`).then(data => {
			dispatch({
				type: OPENSEARCH_NEWUSERTOTAL,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchTop10Movie = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getTop10Movie`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10MOVIE,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchTop10Series = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getTop10Series`).then(data => {
			dispatch({
				type: OPENSEARCH_TOP10SERIES,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchActiveUserPlatform = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getActiveUserByPlatform`).then(data => {
			dispatch({
				type: OPENSEARCH_ACTIVEUSERPLATFORM,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchMovieAll = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getMovieList&collection=content`).then(data => {
			dispatch({
				type: OPENSEARCH_MOVIELIST,
				payload: getOpenSearchDetailList(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchSeriesAll = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getSeriesList&collection=content`).then(data => {
			dispatch({
				type: OPENSEARCH_SERIESLIST,
				payload: getOpenSearchDetailList(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchPlusPurchaseRent = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getPlusPurchaseRent`).then(data => {
			dispatch({
				type: OPENSEARCH_PLUSPURCHASERENT,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchPlusPurchaseBuy = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getPlusPurchaseBuy`).then(data => {
			dispatch({
				type: OPENSEARCH_PLUSPURCHASEBUY,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchBuSwitch = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getBuSwitch`).then(data => {
			dispatch({
				type: OPENSEARCH_BUSWITCH,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchDeviceCoverage = (paramStr) => {
	return dispatch => {
		return searchRecommendApi.get(`/query?${paramStr}&type=getDeviceCoverage`).then(data => {
			dispatch({
				type: OPENSEARCH_DEVICECOVERAGE,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchGetUserProfile = (paramStr) => {

	return searchRecommendApi.get(`/query?${paramStr}&type=getUserProfile`).then(data => {

		return data;
	}).catch(error => {
		throw (error);
	});

};
export const opensearchGetSubscriberCountByExpiryDate = (paramStr) => {

	return searchRecommendApi.get(`/query?${paramStr}&type=getSubscriberCountByExpiryDate&collection=profile`).then(data => {

		return getOpenSearchBuckets(data);
	}).catch(error => {
		throw (error);
	});

};